export enum AnnouncementBarTestIds {
  BAR = 'announcement-bar',
  LEARN_MORE = 'announcement-bar-learn-more',
  DISMISS = 'announcement-bar-dismiss',
  DETAILS = 'announcement-details',
  DETAILS_HEADING = 'announcement-details-heading',
  DETAILS_PUBLISHED_AT = 'announcement-details-published-at',
  DETAILS_VIDEO = 'announcement-details-video',
  DETAILS_IMAGE = 'announcement-details-image',
  DETAILS_TITLE = 'announcement-details-title',
}

export enum AnnouncementsAdminTestIds {
  FORM_BAR_TEXT = 'announcement-form-bar-text',
  FORM_TITLE = 'announcement-form-title',
  FORM_TEXT = 'announcement-form-text',
  FORM_MEDIA_INPUT = 'announcement-form-media-input',
  FORM_MEDIA = 'announcement-form-media',
  FORM_MEDIA_REMOVE = 'announcement-form-media-remove',
  FORM_PUBLISHED_AT = 'announcement-form-published-at',
  FORM_ENDS_AT = 'announcement-form-ends-at',
  FORM_SUBMIT = 'announcement-form-submit',
  FORM_CANCEL = 'announcement-form-cancel',
  FORM_PREVIEW = 'announcement-form-preview',
  FORM_PREVIEW_MODAL = 'announcement-form-preview-modal',
  LIST = 'announcement-list',
  LIST_NEW = 'announcement-list-new',
  LIST_ACTIVE_SWITCH_PREFIX = 'announcement-active-',
  LIST_LIVE_PREFIX = 'announcement-live-',
}
